import { create } from 'zustand';

export interface LmsUserListFilterObject {
	createddate: [Date | null, Date | null];
	status: string; // 'Enrolled' | 'Pending' | 'Rejected' | ''
	competition_tag: boolean;
	source?: string;
	rigidGluePotential: boolean;
	referral_source_c?: string;
}

export interface LmsUserListFilterStore {
	lmsUserListFilter: LmsUserListFilterObject;
	updateFilter: (filterObject: LmsUserListFilterObject) => void;
	resetFilter: () => void;
}

const initialState = {
	lmsUserListFilter: {
		createddate: [null, null] as [Date | null, Date | null],
		status: '',
		competition_tag: false,
		source: '',
		rigidGluePotential: false,
	},
};

export const useLmsUserListFilterStore = create((set) => ({
	...initialState,
	updateFilter: (filterObject: LmsUserListFilterObject): void =>
		set((state: LmsUserListFilterStore) => ({
			lmsUserListFilter: { ...state.lmsUserListFilter, ...filterObject },
		})),
	resetFilter: (): void =>
		set(() => ({
			...initialState,
			updateFilter: (filterObject: LmsUserListFilterObject): void =>
				set((state: LmsUserListFilterStore) => ({
					lmsUserListFilter: { ...state.lmsUserListFilter, ...filterObject },
				})),
			resetFilter: (): void =>
				set(() => ({
					...initialState,
				})),
		})),
}));
